import styled from 'styled-components';
import * as COLORS from '../../theme/colors';
const ColorWrapper = styled.div`
  color: ${({
  color
}) => color ? COLORS[color] : 'inherit'};
`;
export default ColorWrapper;
//# sourceMappingURL=index.js.map